import { useContext } from 'react';
import { ProjectContext } from '../context';

export function useProject() {
  const context = useContext(ProjectContext);
  return { ...context };
}

export default useProject;
